import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLocalKey, getUser, setReturnURL} from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";

const PrivateRoute = ({ component: Component }) => {
    
    const userData = getLocalKey('loggedInUser') ? JSON.parse(getLocalKey('loggedInUser')) : {};
    // let userData = getUser(ROLE.SUPER_ADMIN);

    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token){
                    return <Component/>
                }else{
                    setReturnURL(userData.role);
                    return <Navigate to="/admin/login" />;
                }
            })()}
        </>
    )
}

export default PrivateRoute;